(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ah-b00536-ad-record"] && !Shopify.designMode) return;
  try {
    (() => {
const ORDER_AD_ATTRIBUTE = '__ah_b00536_ad_touch_v1';
const LINE_AD_PROPERTY = '_ah_b00536_ad_touch_v1';
const TOUCH_TTL = 7 * 24 * 60 * 60 * 1000;

function matchAdLanding(href, registry) {
  let url;
  try { url = new URL(href); } catch { return null; }
  if (url.origin !== 'https://arctichunter-eg.com') return null;
  const keys = ['ah_ref', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  if (keys.some(key => url.searchParams.getAll(key).length !== 1)) return null;
  const hits = registry.filter(asset => asset.id === url.searchParams.get('ah_ref') &&
    asset.platform === url.searchParams.get('utm_source') &&
    asset.type === url.searchParams.get('utm_medium') &&
    asset.campaign === url.searchParams.get('utm_campaign') &&
    asset.content === url.searchParams.get('utm_content') && asset.path === url.pathname);
  return hits.length === 1 ? hits[0] : null;
}

function makeAdRecord(asset, at) {
  if (!asset || !Number.isFinite(at)) throw Error('A validated asset and timestamp are required');
  return {v: 1, evidence: 'client_declared_tagged_link', id: asset.id,
    source: asset.platform, medium: asset.type, campaign: asset.campaign,
    content: asset.content, at: new Date(at).toISOString()};
}

function validateAdRecord(value, registry, orderCreatedAt) {
  let record;
  try { record = JSON.parse(value); } catch { return {valid: false, reason: 'invalid_json'}; }
  if (record?.v !== 1 || record.evidence !== 'client_declared_tagged_link') {
    return {valid: false, reason: 'unsupported_record'};
  }
  const at = Date.parse(record.at), orderAt = Date.parse(orderCreatedAt);
  if (!Number.isFinite(at) || !Number.isFinite(orderAt) || at > orderAt || orderAt - at > TOUCH_TTL) {
    return {valid: false, reason: 'outside_seven_day_window'};
  }
  const hits = registry.filter(asset => asset.id === record.id && asset.platform === record.source &&
    asset.type === record.medium && asset.campaign === record.campaign && asset.content === record.content);
  if (hits.length !== 1) return {valid: false, reason: 'unknown_or_conflicting_asset'};
  return {valid: true, assetId: record.id, evidence: record.evidence,
    qualification: 'Tagged-link evidence, not proof of a paid click or exclusive causality'};
}

function reconcileAdEvidence(journeyAssetIds, recordResult) {
  const assets = [...new Set([...(journeyAssetIds || []), ...(recordResult.valid ? [recordResult.assetId] : [])])];
  return {assetIds: assets, bucket: assets.length > 1 ? 'mixed_tagged_touches' :
    assets.length === 1 ? 'tagged_touch' : 'unknown',
    orderRecordValid: recordResult.valid === true};
}

function readOrderAdRecords(order, registry) {
  const sources = [{source:'order',attributes:order.customAttributes || [],key:ORDER_AD_ATTRIBUTE},
    ...(order.lineItems?.nodes || []).filter(line =>
      line.product?.id === 'gid://shopify/Product/7136128958524' &&
      line.variant?.id === 'gid://shopify/ProductVariant/40653340770364')
      .map((line,index)=>({source:`product_line_${index}`,attributes:line.customAttributes || [],key:LINE_AD_PROPERTY}))];
  const records = sources.flatMap(source => {
    const values=source.attributes.filter(x=>x.key===source.key && x.value).map(x=>x.value);
    if (!values.length) return [];
    return [{source:source.source,...(values.length===1 ? validateAdRecord(values[0],registry,order.createdAt) :
      {valid:false,reason:'duplicate_record_keys'})}];
  });
  const assetIds=[...new Set(records.filter(x=>x.valid).map(x=>x.assetId))];
  const summary=assetIds.length===1 ? {valid:true,assetId:assetIds[0],
    evidence:'client_declared_tagged_link',qualification:'Tagged-link evidence, not proof of a paid click or exclusive causality'} :
    {valid:false,reason:assetIds.length>1?'mixed_record_assets':records.length?'invalid_record':'no_order_record'};
  return {records,assetIds,summary};
}

function syncProductAdFields(doc, value) {
  for (const input of doc.querySelectorAll?.('input[data-ah-b00536-ad-field]') || []) {
    input.value=value || '';
    input.disabled=!value;
  }
}

async function clearProductAdProperties(win, root) {
  try {
    const response=await win.fetch(root+'cart.js', {credentials:'same-origin',signal:AbortSignal.timeout(3000)});
    if (!response.ok || typeof response.json!=='function') return false;
    const cart=await response.json();
    if (!Array.isArray(cart.items)) return false;
    for (const line of cart.items) {
      if (String(line.product_id)!=='7136128958524' || String(line.variant_id)!=='40653340770364' ||
          !line.properties?.[LINE_AD_PROPERTY]) continue;
      if (typeof line.key!=='string' || !line.key) return false;
      const cleared=await win.fetch(root+'cart/change.js', {method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:line.key,properties:{...line.properties,[LINE_AD_PROPERTY]:''}}),
        signal:AbortSignal.timeout(3000)});
      if (!cleared.ok) return false;
    }
    return true;
  } catch { return false; }
}

function installAdRecorder(win, doc, registry) {
  if (win.__ahB00536RecorderInstalled) return;
  win.__ahB00536RecorderInstalled = true;
  const storageKey = 'ah_b00536_tagged_touch_v1';
  const asset = matchAdLanding(win.location.href, registry);
  let pending, busy = false, sentValue, revision = 0;
  const allowed = () => {
    try {
      const privacy = win.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed() === true && privacy?.marketingAllowed() === true;
    } catch { return false; }
  };
  const run = async () => {
    revision++;
    const observedRevision = revision;
    const privacyKnown = Boolean(win.Shopify?.customerPrivacy);
    let value;
    if (!allowed()) {
      pending = undefined;
      try { win.sessionStorage.removeItem(storageKey); } catch {}
      syncProductAdFields(doc, '');
      if (!privacyKnown) return;
      value = '';
    } else {
      if (asset && !pending) pending = makeAdRecord(asset, Date.now());
      if (!pending) {
        try {
          const saved = win.sessionStorage.getItem(storageKey);
          if (saved && validateAdRecord(saved, registry, new Date().toISOString()).valid) pending = JSON.parse(saved);
        } catch {}
      }
      if (!pending) return;
      value = JSON.stringify(pending);
      try { win.sessionStorage.setItem(storageKey, value); } catch {}
      syncProductAdFields(doc, value);
    }
    if (busy || value === sentValue) return;
    busy = true;
    try {
      const root = win.Shopify?.routes?.root;
      if (!root || !root.startsWith('/') || root.startsWith('//')) return;
      const response = await win.fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({attributes: {[ORDER_AD_ATTRIBUTE]: value}}),
        signal: AbortSignal.timeout(3000)
      });
      if (response.ok && (value || await clearProductAdProperties(win, root))) sentValue = value;
    } catch {} finally {
      busy = false;
      if (revision !== observedRevision) await run();
    }
  };
  doc.addEventListener('visitorConsentCollected', run);
  doc.addEventListener('DOMContentLoaded', run, {once: true});
  win.addEventListener('pageshow', run);
  run();
  if (!win.Shopify?.customerPrivacy && typeof win.Shopify?.loadFeatures === 'function') {
    win.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (!error) run();
    });
  }
}

const registry = [{"id":"b00536_sep28_one_bag_proof_paid_v1","type":"paid_social","platform":"meta","campaign":"b00536_sep28_one_bag_proof","content":"one_bag_proof_video_v1","path":"/ar-eg/products/arctic-hunter-b00536-laptop-backpack-black"},{"id":"b00536_oct06_order_record_qa_01","type":"paid_social","platform":"meta","campaign":"b00536_oct06_order_record_qa","content":"controlled_order_record_01","path":"/ar-eg/products/arctic-hunter-b00536-laptop-backpack-black"},{"id":"b00536_oct06_buy_now_qa_02","type":"paid_social","platform":"meta","campaign":"b00536_oct06_buy_now_qa","content":"controlled_buy_now_02","path":"/ar-eg/products/arctic-hunter-b00536-laptop-backpack-black"},{"id":"b00536_oct06_buy_now_fixed_qa_03","type":"paid_social","platform":"meta","campaign":"b00536_oct06_buy_now_fixed_qa","content":"controlled_buy_now_fixed_03","path":"/ar-eg/products/arctic-hunter-b00536-laptop-backpack-black"},{"id":"b00536_oct06_fit_paid_v6","type":"paid_social","platform":"meta","campaign":"b00536_oct06_fit","content":"fit_video_v6","path":"/ar-eg/products/arctic-hunter-b00536-laptop-backpack-black"},{"id":"b00536_nov01_gallery_paid_v1","type":"paid_social","platform":"meta","campaign":"b00536_gallery_nov01","content":"fit_v7_gallery_six","path":"/ar-eg/products/arctic-hunter-b00536-laptop-backpack-black"},{"id":"b00536_nov03_v8_paid_v1","type":"paid_social","platform":"meta","campaign":"b00536_v8_nov03","content":"fit_v8_2_take_your_day","path":"/ar-eg/products/arctic-hunter-b00536-laptop-backpack-black"}];
installAdRecorder(window, document, registry);
})();
  } catch(e) { console.error(e); }
})();

})();
